(() => {
  const ROOT_SELECTOR = '[data-beamx-aov]';
  const SELECT_SELECTOR = '[data-bx-aov-select]';
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function productInfoForBox(box) {
    const productId = box?.dataset.mainProductId;
    if (productId) {
      const exact = document.querySelector(`product-info[data-product-id="${productId}"]`);
      if (exact) return exact;
    }
    return document.querySelector('product-info');
  }

  function placeBox(box) {
    const productInfo = productInfoForBox(box);
    if (!box || !productInfo) return;

    const mainSectionId = productInfo.dataset.section || '';
    if (mainSectionId) box.dataset.sectionId = mainSectionId;

    const slot = productInfo.querySelector('.product-purchase-widget-slot');
    const actions = productInfo.querySelector('.product-purchase-actions-standalone');

    if (MOBILE_QUERY.matches) {
      if (slot && box.parentNode !== slot) {
        slot.classList.add('has-beamx-aov');
        slot.insertBefore(box, slot.firstChild);
      }
      return;
    }

    if (slot) slot.classList.remove('has-beamx-aov');
    if (actions && box.nextElementSibling !== actions) {
      actions.parentNode.insertBefore(box, actions);
    }
  }

  function deviceLabel() {
    return MOBILE_QUERY.matches ? 'mobile' : 'desktop';
  }

  function getSelectedButtons(box) {
    return Array.from(box.querySelectorAll(`${SELECT_SELECTOR}[aria-pressed="true"]`));
  }

  function getSelectedVariantIds(box) {
    return [...new Set(getSelectedButtons(box).map((button) => Number(button.dataset.variantId)).filter(Boolean))];
  }

  function itemFromButton(button) {
    return {
      variantId: Number(button.dataset.variantId),
      productHandle: button.dataset.productHandle || '',
      price: Number(button.dataset.price || 0),
      rank: Number(button.dataset.rank || 0),
      role: button.dataset.role || '',
      source: button.dataset.source || ''
    };
  }

  function getSelectedItems(box) {
    const seen = new Set();
    return getSelectedButtons(box).reduce((items, button) => {
      const item = itemFromButton(button);
      if (!item.variantId || seen.has(item.variantId)) return items;
      seen.add(item.variantId);
      items.push(item);
      return items;
    }, []);
  }

  function getPresentedItems(box) {
    const seen = new Set();
    return Array.from(box.querySelectorAll(SELECT_SELECTOR)).reduce((items, button) => {
      const item = itemFromButton(button);
      if (!item.variantId || seen.has(item.variantId)) return items;
      seen.add(item.variantId);
      items.push(item);
      return items;
    }, []);
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('bg-BG', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `€${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  }

  function selectedTotal(box) {
    return getSelectedItems(box).reduce((sum, item) => sum + item.price, 0);
  }

  function track(box, eventName, detail = {}) {
    if (!box || box.dataset.designMode === 'true') return;

    const payload = {
      event: eventName,
      beamx_aov: true,
      device: deviceLabel(),
      main_product_id: box.dataset.mainProductId || '',
      main_product_handle: box.dataset.mainProductHandle || '',
      main_price: Number(box.dataset.mainPrice || 0),
      ...detail
    };

    document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
  }

  function trackView(box) {
    if (!box || box.dataset.viewTracked === 'true') return;
    box.dataset.viewTracked = 'true';

    const items = getPresentedItems(box);
    track(box, 'beamx_aov_view', {
      addon_variant_ids: items.map((item) => item.variantId),
      addon_product_handles: items.map((item) => item.productHandle),
      addon_roles: items.map((item) => item.role),
      addon_sources: items.map((item) => item.source),
      addon_prices: items.map((item) => item.price),
      addon_count: items.length
    });
  }

  function installViewTracking(box) {
    if (!box || box.dataset.viewObserverInstalled === 'true') return;
    box.dataset.viewObserverInstalled = 'true';

    if (!('IntersectionObserver' in window)) {
      trackView(box);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          trackView(box);
          observer.disconnect();
        }
      });
    }, { threshold: [0.2] });

    observer.observe(box);
  }

  function setVariantSelected(box, variantId, selected) {
    box.querySelectorAll(`${SELECT_SELECTOR}[data-variant-id="${variantId}"]`).forEach((button) => {
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.textContent = selected
        ? (button.dataset.selectedLabel || 'Добавено ✓')
        : (button.dataset.defaultLabel || '+ Добави');
    });
  }

  function progressMarkup(box, selectedCount, addonTotal) {
    const discountsEnabled = box.dataset.discountsEnabled === 'true';
    const totalText = addonTotal > 0 ? ` · +${formatMoney(addonTotal)} към поръчката` : '';

    if (discountsEnabled) {
      if (selectedCount <= 0) return '🔥 Добави още 1 продукт → вземи <strong>-3%</strong>';
      if (selectedCount === 1) return `✓ <strong>-3% отключени</strong>${totalText} · Добави още 1 → <strong>-5%</strong>`;
      if (selectedCount === 2) return `🔥 <strong>-5% отключени</strong>${totalText} · Добави още 1 → <strong>-7%</strong>`;
      return `🎉 Максимална отстъпка <strong>-7%</strong>${totalText}`;
    }

    if (selectedCount <= 0) return 'Избери допълнение и го добави с основния продукт.';
    if (selectedCount === 1) return `✓ <strong>1 допълнение избрано</strong>${totalText}`;
    return `✓ <strong>${selectedCount} допълнения избрани</strong>${totalText}`;
  }

  function updateProgress(box) {
    const count = getSelectedVariantIds(box).length;
    const total = selectedTotal(box);
    const markup = progressMarkup(box, count, total);

    box.querySelectorAll('[data-bx-aov-progress]').forEach((node) => {
      node.innerHTML = markup;
    });

    box.dataset.selectedCount = String(count);
    box.dataset.selectedAddonTotal = String(total);
  }

  function initBox(box) {
    if (!box) return;
    placeBox(box);
    installViewTracking(box);
    if (box.dataset.initialized === 'true') return;
    box.dataset.initialized = 'true';

    box.addEventListener('click', (event) => {
      const button = event.target.closest(SELECT_SELECTOR);
      if (!button || !box.contains(button)) return;
      event.preventDefault();

      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      const selected = button.getAttribute('aria-pressed') !== 'true';
      setVariantSelected(box, variantId, selected);
      updateProgress(box);

      track(box, 'beamx_aov_toggle', {
        addon_variant_id: variantId,
        addon_product_handle: button.dataset.productHandle || '',
        addon_price: Number(button.dataset.price || 0),
        rank: Number(button.dataset.rank || 0),
        role: button.dataset.role || '',
        source: button.dataset.source || '',
        selected,
        selected_count: getSelectedVariantIds(box).length,
        selected_addon_total: selectedTotal(box)
      });
    });

    updateProgress(box);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((box) => {
      placeBox(box);
      initBox(box);
    });
  }

  function boxForForm(form) {
    const productInfo = form.closest('product-info');
    if (!productInfo) return null;
    const sectionId = productInfo.dataset.section;
    if (!sectionId) return null;

    return Array.from(document.querySelectorAll(ROOT_SELECTOR)).find(
      (box) => box.dataset.sectionId === sectionId
    ) || null;
  }

  function continueMainProduct(form, submitButton, originalText) {
    form.dataset.beamxAovContinue = 'true';

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }

    if (typeof form.requestSubmit === 'function') {
      if (submitButton instanceof HTMLButtonElement) form.requestSubmit(submitButton);
      else form.requestSubmit();
    } else {
      form.submit();
    }
  }

  window.BeamxAov = {
    analyticsVersion: 'shopify-native-v1',
    getBoxForProduct(productId) {
      return Array.from(document.querySelectorAll(ROOT_SELECTOR)).find(
        (box) => String(box.dataset.mainProductId) === String(productId)
      ) || null;
    },
    getSelectedItems(productId) {
      const box = this.getBoxForProduct(productId) || document.querySelector(ROOT_SELECTOR);
      return box ? getSelectedItems(box) : [];
    },
    getSelectedVariantIds(productId) {
      return this.getSelectedItems(productId).map((item) => item.variantId);
    },
    clear(productId) {
      const box = this.getBoxForProduct(productId) || document.querySelector(ROOT_SELECTOR);
      if (!box) return;
      getSelectedVariantIds(box).forEach((id) => setVariantSelected(box, id, false));
      updateProgress(box);
    }
  };

  if (!window.beamxAovSubmitInstalled) {
    window.beamxAovSubmitInstalled = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      if (form.dataset.beamxAovContinue === 'true') {
        delete form.dataset.beamxAovContinue;
        return;
      }

      const box = boxForForm(form);
      if (!box) return;

      const selectedItems = getSelectedItems(box);
      if (!selectedItems.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = event.submitter || form.querySelector('[type="submit"]');
      const originalText = submitButton ? submitButton.textContent : '';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Добавям продуктите...';
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: selectedItems.map((item) => ({
              id: item.variantId,
              quantity: 1,
              properties: {
                _beamx_aov: 'true',
                _beamx_aov_parent: box.dataset.mainProductHandle || '',
                _beamx_aov_parent_id: box.dataset.mainProductId || '',
                _beamx_aov_rank: String(item.rank || ''),
                _beamx_aov_role: item.role || '',
                _beamx_aov_source: item.source || ''
              }
            }))
          })
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Неуспешно добавяне на допълнителен продукт.');
        }

        track(box, 'beamx_aov_addons_added', {
          addon_variant_ids: selectedItems.map((item) => item.variantId),
          addon_product_handles: selectedItems.map((item) => item.productHandle),
          addon_roles: selectedItems.map((item) => item.role),
          addon_sources: selectedItems.map((item) => item.source),
          addon_count: selectedItems.length,
          addon_total: selectedTotal(box)
        });

        continueMainProduct(form, submitButton, originalText);
      } catch (error) {
        console.error('BeamX AOV add-on error; continuing main product sale:', error);

        track(box, 'beamx_aov_addons_failed', {
          addon_variant_ids: selectedItems.map((item) => item.variantId),
          addon_count: selectedItems.length,
          error: String(error?.message || error)
        });

        continueMainProduct(form, submitButton, originalText);
      }
    }, true);
  }

  let resizeTimer;
  const handleBreakpointChange = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(initAll, 60);
  };

  if (typeof MOBILE_QUERY.addEventListener === 'function') {
    MOBILE_QUERY.addEventListener('change', handleBreakpointChange);
  } else if (typeof MOBILE_QUERY.addListener === 'function') {
    MOBILE_QUERY.addListener(handleBreakpointChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
